module.exports = __webpack_public_path__ + "static/iPhone-e275cd1615d6ef9fe8cbb352ad55e149.png";